module.exports = __webpack_public_path__ + "static/img/phone-bg.220d87aa.png";